import { render, staticRenderFns } from "./VistaPlanes.vue?vue&type=template&id=0372f453&scoped=true"
import script from "./VistaPlanes.vue?vue&type=script&lang=js"
export * from "./VistaPlanes.vue?vue&type=script&lang=js"
import style0 from "./VistaPlanes.vue?vue&type=style&index=0&id=0372f453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0372f453",
  null
  
)

export default component.exports